<template>
  <div id="main">
    <router-view />
    <loading />
  </div>
</template>

<script>
require('@/assets/css/template.css')
import loading from '@/view/module/Loading.vue'
export default {
  name: 'App',
  components: { loading },
  mounted() {
    localStorage.setItem("enableMT5", "true")
  }
}
</script>
